import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding } from '@angular/core';

/**
 * Displays a nice preloader image that can be shown before the app starts.  Should be placed in the top level AppComponent.
 * To use, make sure tcc-ui-preloader.css has been loaded.
 * The preloader css classes can also be used before the app is bootstrapped.
 * @example
 * **Before Bootstrapped**
 * ```
 * <my-app>
 *   <div class="tcc-preloader">
 *     <div class="tcc-preloader-content">App Name</div>
 *   </div>
 * </my-app>
 * ```
 * **As component**
 * ```
 * <tcc-preloader *ngIf="isLoaded=false">App Name</tcc-preloader></pre></p>
 * ```
 */
@Component({
  selector: 'tcc-preloader',
  template: `
<div class="tcc-preloader">
    <div class="tcc-preloader-content">
        <ng-content></ng-content>
    </div>
</div>
`,
  animations: [
    trigger('hostOut', [
      transition(':enter', [
        style({
          opacity: 1
        })
      ]),
      transition(':leave', [
        style({
          opacity: 1
        }),
        animate('.5s ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class PreloaderComponent {
  /** this is for animation binding to the host element */
  @HostBinding('@hostOut') readonly hostOut = true;
}
